import { deleteNode } from "@/lib/formatting.js";

export default {
  // 设置区分工商租户(2)和其他租户(1)
  setVendor(state, vendor) {
    state.vendor = vendor;
    localStorage.setItem("vendor", vendor);
  },
  // 设置identity(身份) - 区分商户(1)和员工(2)
  setIdentity(state, identity) {
    state.identity = identity;
    localStorage.setItem("identity", identity);
  },
  // 设置token
  setToken(state, token) {
    state.token = token;
    localStorage.setItem("token", token);
  },
  // 设置shopId
  setShopId(state, shopId) {
    state.shopId = shopId;
    localStorage.setItem("shopId", shopId);
  },
  // 设置用户名
  setUserName(state, username) {
    state.username = username;
    localStorage.setItem("username", username);
  },
  // 设置面包屑
  setCrumbsNav(state, crumbsNav) {
    state.crumbsNav = crumbsNav;
    localStorage.setItem("crumbsNav", JSON.stringify(crumbsNav));
  },
  // 设置权限
  setJurisdiction(state, jurisdiction) {
    /*
      注意：设置权限需要保证先拿到店铺的信息（即TenantInfo，里面包含了区分工商租户和其他租户的字段，是否是子店铺的字段）
      1.工商租户(vendor == 2)需要屏蔽所有购买功能的页面和权限，屏蔽【订购服务(模块)】
      2.父店铺需要屏蔽【课程申请】页面和权限，子店铺需要屏蔽【子店铺】页面和权限
      3.生产环境屏蔽菜单管理
     */
    const tenantInfo = state.tenant.tenantInfo;
    const vendor = tenantInfo.vendor;
    const isSubTenant = tenantInfo.isSubTenant;
    const jurisdictionCopy = JSON.parse(JSON.stringify(jurisdiction));
    // 1.工商租户(vendor == 2)屏蔽
    if (vendor == 2) {
      // 页面
      const urlRemoveList = ["/purchase"];
      urlRemoveList.forEach(path => {
        jurisdictionCopy.menuList = deleteNode(
          jurisdictionCopy.menuList,
          "url",
          path
        );
      });
      // 权限
      const permissionsRemoveList = ["purchase:versions", "purchase:resource"];
      permissionsRemoveList.forEach(code => {
        const idx = jurisdictionCopy.permissions.indexOf(code);
        if (idx != -1) {
          jurisdictionCopy.permissions.splice(idx, 1);
        }
      });
    }
    // 2.父店铺屏蔽、子店铺屏蔽
    if (isSubTenant) {
      // 页面
      jurisdictionCopy.menuList = deleteNode(
        jurisdictionCopy.menuList,
        "url",
        "/store/merchant"
      );
      // 权限
      const idx = jurisdictionCopy.permissions.indexOf("store:merchant");
      if (idx != -1) {
        jurisdictionCopy.permissions.splice(idx, 1);
      }
    } else {
      // 页面
      jurisdictionCopy.menuList = deleteNode(
        jurisdictionCopy.menuList,
        "url",
        "/store/apply"
      );
      // 权限
      const idx = jurisdictionCopy.permissions.indexOf("store:apply");
      if (idx != -1) {
        jurisdictionCopy.permissions.splice(idx, 1);
      }
    }
    // 3.生产环境屏蔽
    if (process.env.NODE_ENV != "development") {
      jurisdictionCopy.menuList = deleteNode(
        jurisdictionCopy.menuList,
        "url",
        "/setting/menu"
      );
      const idx = jurisdictionCopy.permissions.indexOf("setting:menu");
      if (idx != -1) {
        jurisdictionCopy.permissions.splice(idx, 1);
      }
    }

    state.jurisdiction = jurisdictionCopy;
    localStorage.setItem("jurisdiction", JSON.stringify(jurisdictionCopy));
  },
  // 设置套餐
  setCombo(state, combo) {
    state.combo = combo;
    localStorage.setItem("combo", JSON.stringify(combo));
  },
  // 监测侧边菜单宽度
  setChangWidth(state, changWidth) {
    state.changWidth = changWidth;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js